import React from 'react';
import PropTypes from 'prop-types';

import Heading from '@marvelapp/marvel-ui/heading';
import Spacing from '@marvelapp/marvel-ui/spacing';

export default function NavDropdownHeading({ children }) {
  return (
    <Spacing type="margin" size="m">
      <Heading tag="h3" weight="bold" size="xs" color="licorice">
        <span className="textTransform-uppercase">{children}</span>
      </Heading>
    </Spacing>
  );
}

NavDropdownHeading.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavDropdownHeading/index.js